<template>
    <!-- Start Main Content -->
    <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="card">
            <h2 class="card-title">Member List Details</h2>
        </div>
        <div class="card">
            <h2>Member Details</h2>
            <table v-if="memberData" class="min-w-full border-collapse border border-gray-300">
              <thead>
                
              </thead>
              <tbody>
                <tr>
                  <td class="border border-gray-300 px-4 py-2">First Name:</td>
                  <td class="border border-gray-300 px-4 py-2">{{ memberData.firstname }}</td>
                  <td class="border border-gray-300 px-4 py-2">Last Name:</td>
                  <td class="border border-gray-300 px-4 py-2">{{ memberData.lastname }}</td>
                  <td class="border border-gray-300 px-4 py-2">Address:</td>
                  <td class="border border-gray-300 px-4 py-2">{{ memberData.address }}</td>
                  <td class="border border-gray-300 px-4 py-2">City:</td>
                  <td class="border border-gray-300 px-4 py-2">{{ memberData.city }}</td>
                </tr>
                <tr>
                  <td class="border border-gray-300 px-4 py-2">Gender:</td>
                  <td class="border border-gray-300 px-4 py-2">{{ memberData.gender }}</td>
                  <td class="border border-gray-300 px-4 py-2">Phone Number:</td>
                  <td class="border border-gray-300 px-4 py-2">{{ memberData.phonenumber }}</td>
                  <td class="border border-gray-300 px-4 py-2">State:</td>
                  <td class="border border-gray-300 px-4 py-2">{{ memberData.state }}</td>
                </tr>
              </tbody>
            </table>

            <h2 class="pt-2">Subscription Details</h2>
            <table  class="min-w-full border-collapse border border-gray-300">
              <thead>
                <th>Package Name</th>
                <th>Cost</th>
                <th>Days</th>
                <th>Start Date</th>
                <th>End Date</th>
              </thead>
              <tbody>
                <tr v-for="(item ,index)  in subscriptionInfo">
                  <td>{{item.pkg_name}}</td>
                  <td>{{item.cost}}</td>
                  <td>{{item.packagedays}}</td>
                  <td>{{ getOnlyDate(item.startdate+"") }} </td>
                  <td>{{ getOnlyDate(item.enddate+"")  }}</td>
                </tr>
              </tbody>
            </table>

            <h2>Service Subscription Details</h2>
            <table  class="min-w-full border-collapse border border-gray-300">
              <thead>
                <th>From Date</th>
                <th>To Date</th>
                <th>Total Amount</th>
                <th>Paid</th>
                <th>Note</th>
              </thead>
              <tbody>
                <tr v-for="(item ,index)  in serviceSubscription">
                  <td>{{item.from_date}}</td>
                  <td>{{item.to_date}}</td>
                  <td>{{item.total_amt}}</td>
                  <td>{{item.paid}}</td>
                  <td>{{item.note}}</td>
                </tr>
              </tbody>
            </table>
            <h2>Accounting Details</h2>
            <table  class="min-w-full border-collapse border border-gray-300">
              <thead>
                <th>Start Date</th>
                <th>Paid</th>
                <th>Payment Type</th>
                <th>Note</th>
                <th>Total</th>
              </thead>
              <tbody>
                <tr v-for="(item ,index)  in accountingInfo">
                  <td>{{ getOnlyDate(item.startdate+"") }}</td>
                  <td>{{item.paid}}</td>
                  <td>{{item.paymenttype}}</td>
                  <td>{{item.note}}</td>
                  <td>{{item.total}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          
    </div>
    <!-- End Main Content -->
       

    


</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';

export default {
name: 'AddProduct',
components: {
 
} ,
mounted(){
 
},
data() {
    const today = new Date().toISOString().split('T')[0];
 return {
    memberData: null,
    subscriptionInfo: [],
    serviceSubscription: null,
    accountingInfo: null,
 }
 }, 
 created() {
    const memberId = this.$route.query.id;
    if (memberId) {
      this.fetchMemberDetails(memberId);
    }
  },
methods:{

  getOnlyDate(date){
    
    try {
    if(date){
      var dateHere=date;
      return dateHere.split(' ')[0];
    }else
    return '';
      
    } catch (error) {
      alert(error);
    return '';
    }
    
  },
    fetchMemberDetails(memberId) {
      axios.post(`getMemberDetails`, { id: memberId }).then(response => {
        this.memberData = response.data.customerInfo;
        this.subscriptionInfo = response.data.subscriptionInfo;
        console.log(this.subscriptionInfo);
        this.serviceSubscription = response.data.serviceSubscription;
        this.accountingInfo = response.data.accountingInfo;
        console.log(this.accountingInfo);
      });
    },
//     viewMemberDetails(memberId) {
//     this.$router.push({ name: 'member-details', query: { id: memberId } });
//   }
            
},
}
</script>
<style scoped>
    .invoice-container {
      width: 100%;
      max-width: 800px;
      margin: 0 auto;
      padding: 20px;
      font-family: Arial, sans-serif;
    }
    
    .header {
      text-align: center;
    }
    
    .company-details p {
      margin: 0;
    }
    
    .bill-details {
      margin-top: 20px;
    }
    
    .bill-to, .invoice-info {
      display: inline-block;
      vertical-align: top;
      width: 48%;
    }
    
    .table {
      width: 100%;
      margin-top: 20px;
      border-collapse: collapse;
    }
    
    .table th, .table td {
      border: 1px solid #000;
      padding: 8px;
      text-align: left;
    }
    
    .totals {
      margin-top: 20px;
      text-align: right;
    }
    
    .footer {
      margin-top: 40px;
      text-align: center;
      font-size: 12px;
    }
    </style>